<script>
  import { onMount } from "svelte";
  import { ROUTES } from "@utils/routes.js";
  import { projectListStore } from "@stores/damProjectsStore.js";
  import { useUrlParams } from "@stores/urlStore.js";

  import {
    Pagination,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    DataTable,
    Button,
    ComboBox,
    Select,
    SelectItem,
  } from "carbon-components-svelte";
  import download from "downloadjs";
  import { TextInput, TextArea, SectionWrapper } from "paxray-components-svelte";

  import AnonymizationList from "../components/AnonymizationList.svelte";
  import Edit16 from "carbon-icons-svelte/lib/Edit16";
  import AnonymizationListUi from "../components/AnonymizationListUI.svelte";

  import ButtonNew from "../../../../lib/components/ButtonNew.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { escapeRegExp } from "lib/util/regex.js";
  import RuleDataTable from "../../analysis-frontend/components/RuleDataTable.svelte";
  import LimitationList from "../components/LimitationList.svelte";

  export let isCompleted;

  const { updateProjectStep } = projectListStore;
  const urlParams = useUrlParams();

  let idAnonymization;
  let idLimitation;
  let titlelist = [];
  let applicationLimitations = [];
  let uipage = 1;
  let uipageSize;
  let uilist = [];
  let fulluilist = [];
  let uilistfilterelements = {
    applicationname: [],
    type: [],
    elementclass: [],
  };
  let uilistfilter = {
    applicationname: "*",
    windowtitle: "",
    type: "*",
    elementclass: "*",
    name: "",
    automationid: "",
    in_task_recording: "yes",
  };
  let anonymizationRuleModalOpen = false;
  let anonymizationRuleModalOpenUI = false;
  let currentAnonymizationRuleUI = {
    id: 0,
    name: "",
    automationsearch: "",
    automationreplace: "",
    namesearch: "",
    namereplace: "",
    elementclass: "",
    applicationname: "",
    type: "",
  };
  let currentAnonymizationRule = {
    id: 0,
    name: "",
    search: "",
    replace: "",
  };
  let updated = false;
  let selectedAppRows = [];
  let filteredRowIds = [];
  let offset = 0;
  let limit = 1000;
  let page = 1;
  let pageSize = 10;
  let message = "";

  $: ({ idproject, currentStep } = $urlParams);

  $: {
    if (uilistfilter) filterUIList();
  }

  $: {
    if (updated) {
      getApplications();
      updated = false;
    }
  }

  $: if (idproject) {
    loadProjectData();
  }

  function shouldFilterItem(item, value) {
    if (!item || !item.text) return false;
    if (!value) return true;
    const searchValue = typeof value === "string" ? value : "";
    if (!searchValue) return true;
    return item.text.toLowerCase().includes(searchValue.toLowerCase());
  }

  function exportPreprocessingSteps() {
    fetchWithSession(
      `/api/damprojects/exportDAMAnonymizationRule/` + idAnonymization,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(data, "preprocessing.csv", "text/plain");
      });
  }

  function importPreprocessingSteps() {
    let fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv";
    fileInput.onchange = function () {
      let file = fileInput.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let content = e.target.result;
        importPreprocessingStepsContent(content);
      };
      reader.readAsText(file);
    };
    fileInput.click();
  }

  let anonymizationsupdated = false;

  function importPreprocessingStepsContent(content) {
    fetchWithSession(
      `/api/damprojects/importDAMAnonymizationRule/` + idAnonymization,
      {
        method: "POST",
        body: JSON.stringify({
          file: content,
          checkRules: true,
          idproject: idproject,
        }),
      },
    )
      .then((response) => response.text())
      .then((data) => {
        anonymizationsupdated = true;
      });
  }

  function exportPreprocessingStepsUI() {
    fetchWithSession(
      `/api/damprojects/exportDAMAnonymizationRuleUI/${idAnonymization}`,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(data, "preprocessing.csv", "text/plain");
      });
  }

  function importPreprocessingStepsUI() {
    let fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv";
    fileInput.onchange = function () {
      let file = fileInput.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let content = e.target.result;
        importPreprocessingStepsContentUI(content);
      };
      reader.readAsText(file);
    };
    fileInput.click();
  }

  function importPreprocessingStepsContentUI(content) {
    fetchWithSession(
      `/api/damprojects/importDAMAnonymizationRuleUI/${idAnonymization}`,
      {
        method: "POST",
        body: JSON.stringify({
          idproject: idproject,
          projectStep: 1,
          file: content,
        }),
      },
    )
      .then((response) => response.text())
      .then((data) => {
        idAnonymization = idAnonymization;
      });
  }

  function filterUIList() {
    console.log({ uilistfilter });

    uilist = fulluilist.filter((item) => {
      let matches = true;
      const appFilter = uilistfilter.applicationname || "*";
      const classFilter = uilistfilter.elementclass || "*";
      const typeFilter = uilistfilter.type || "*";
      if (appFilter !== "*") {
        matches =
          matches &&
          item.applicationname.toLowerCase() === appFilter.toLowerCase();
      }
      if (classFilter !== "*") {
        matches =
          matches &&
          item.elementclass.toLowerCase() === classFilter.toLowerCase();
      }
      if (uilistfilter.windowtitle != "") {
        matches =
          matches &&
          item.windowtitle
            .toLowerCase()
            .match(uilistfilter.windowtitle.toLowerCase()) !== null;
      }
      if (typeFilter !== "*") {
        matches =
          matches && item.type.toLowerCase() === typeFilter.toLowerCase();
      }
      if (uilistfilter.name != "") {
        matches =
          matches &&
          item.name.toLowerCase().match(uilistfilter.name.toLowerCase()) !=
            null;
      }
      if (uilistfilter.automationid != "") {
        matches =
          matches &&
          item.automationid
            .toLowerCase()
            .match(uilistfilter.automationid.toLowerCase()) != null;
      }
      if (uilistfilter.in_task_recording != "*") {
        matches =
          matches &&
          item.in_task_recording ==
            (uilistfilter.in_task_recording == "yes" ? true : false);
      }
      return matches;
    });
  }

  function getApplications() {
    fetchWithSession(
      `/api/damprojects/getAnonymizationLog?idproject=` + idproject,
    )
      .then((res) => res.json())
      .then((data) => {
        titlelist = data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getUIElements() {
    fetchWithSession(
      `/api/damprojects/getAnonymizationUILog?idproject=` +
        idproject +
        `&offset=` +
        offset +
        `&limit=` +
        limit,
    )
      .then((res) => res.json())
      .then((data) => {
        fulluilist = data.elements;
        console.log(fulluilist);
        uilistfilterelements = data.filterelements;

        filterUIList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function goMainRecording() {
    fetchWithSession("/api/damprojects/startMainRecording", {
      method: "POST",
      body: JSON.stringify({ idproject: idproject, message: message }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          fetchWithSession(
            `/api/damprojects/completeDAMProjectStep/${idproject}/2`,
            {
              method: "POST",
            },
          )
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                isCompleted = true;
                currentStep += 1;
                updateProjectStep(idproject, currentStep);
              }
            });
        }
      });
  }

  function newRuleFromEntryUI(entry) {
    const automationVal = entry.automationpreview || entry.automationid || "";
    const nameVal = entry.namepreview || entry.name || "";

    currentAnonymizationRuleUI = {
      id: 0,
      name: nameVal,
      automationsearch: escapeRegExp(automationVal),
      automationreplace: automationVal,
      namesearch: escapeRegExp(nameVal),
      namereplace: nameVal,
      elementclass: entry.elementclass,
      applicationname: entry.applicationname,
      type: entry.type,
    };
    anonymizationRuleModalOpenUI = true;
  }

  function newRuleFromEntry(entry) {
    currentAnonymizationRule = {
      id: 0,
      applicationname: entry.applicationname,
      name: entry.preview,
      search: escapeRegExp(entry.preview),
      replace: entry.preview,
    };
    anonymizationRuleModalOpen = true;
  }

  function createRuleAI() {
    let selectedRows = titlelist.filter((row) =>
      selectedAppRows.includes(row.id),
    );
    let selectedWindowtitles = selectedRows.map((row) => row.preview);
    fetchWithSession(`/api/damprojects/generateGeneralization`, {
      method: "POST",
      body: JSON.stringify({
        windowtitles: selectedWindowtitles,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        currentAnonymizationRule = {
          id: 0,
          name: data["regexs"][0],
          search: data["regexs"][0],
          replace: data["generalizations"][0],
        };
        anonymizationRuleModalOpen = true;
      });
  }

  function goToKeywordAssistant() {
    window.open(
      ROUTES.dam.keywordAssistant + `?idproject=${idproject}`,
      "_blank",
    );
  }

  function goToCaseIdAssistant() {
    window.open(
      ROUTES.dam.caseIdAssistant + `?idproject=${idproject}`,
      "_blank",
    );
  }

  function goToNumberAssistant() {
    window.open(
      ROUTES.dam.numberRangeAssistant + `?idproject=${idproject}`,
      "_blank",
    );
  }

  function goToCandidateRules() {
    window.open(
      ROUTES.dam.anonymizationAssistant +
        `?idproject=${idproject}&step=${currentStep}`,
      "_blank",
    );
  }

  function getPreprocessingRules() {
    fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/1`)
      .then((res) => res.json())
      .then((data) => {
        idAnonymization = data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function loadProjectData() {
    getPreprocessingRules();

    fetchWithSession(`/api/damprojects/getProjectLimitations/${idproject}/1`)
      .then((res) => res.json())
      .then((data) => {
        idLimitation = data;
        fetchWithSession(`/api/damprojects/limitations/${idLimitation}`)
          .then((res) => res.json())
          .then((data) => {
            applicationLimitations = data.items;
          })
          .catch((err) => {
            console.error();
            err;
          });
      });
  }
</script>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div
      style="display: flex; flex-direction:row; gap:1rem; align-items: center;"
    >
      <div class="table_heading info_wrapper">
        <h5>
          Anonymization Rules. Only continue, if all personal information is
          fully removed from the recordings!
        </h5>
        <div class="info">
          Here, you can also set more restrictive whitelists to exclude
          applications that can not be anonymized.
        </div>
      </div>
      <ButtonNew
        on:click={goToNumberAssistant}
        secondary={true}
        setting={true}
        text="Number Assistant"
      ></ButtonNew>
      <ButtonNew
        on:click={goToCaseIdAssistant}
        secondary={true}
        setting={true}
        text="Case Assistant"
      ></ButtonNew>
    </div>
    <!-- @Adrian bitte ausfüllen, was genau das ist -->
    <div style="display: flex; flex-direction:row; gap:1rem">
      <div class="table_heading">
        <h5>Applications</h5>
        <div class="info"></div>
      </div>
      <ButtonNew
        on:click={exportPreprocessingSteps}
        secondary={true}
        setting={true}
        text="Export"
      ></ButtonNew>
      <ButtonNew
        on:click={importPreprocessingSteps}
        secondary={true}
        setting={true}
        text="Import"
      ></ButtonNew>
      <ButtonNew
        on:click={goToKeywordAssistant}
        secondary={true}
        setting={true}
        text="Keyword Assistant"
      ></ButtonNew>
      <ButtonNew
        on:click={goToCandidateRules}
        secondary={true}
        setting={true}
        text="Rule Assistant"
      ></ButtonNew>
    </div>

    <AnonymizationList
      {idAnonymization}
      editable={true}
      bind:currentAnonymizationRule
      bind:anonymizationRuleModalOpen
      bind:updated={anonymizationsupdated}
    />
    <div>
      <RuleDataTable
        bind:currentAnonymizationRule
        bind:modalOpen={anonymizationRuleModalOpen}
        projectStep={1}
      />
    </div>
    <!-- @Adrian nur auskommentiert, falls neuer button spinnen sollte -->
    <!-- <Button on:click={getApplications}>Apply Rules</Button> -->

    <!-- @Adrian bitte ausfüllen, was genau das ist -->

    <div style="display: flex; flex-direction:row; gap:1rem">
      <div class="table_heading">
        <h5>UI Elements</h5>
        <div class="info"></div>
      </div>
      <ButtonNew
        on:click={exportPreprocessingStepsUI}
        secondary={true}
        setting={true}
        text="Export"
      ></ButtonNew>
      <ButtonNew
        on:click={importPreprocessingStepsUI}
        secondary={true}
        setting={true}
        text="Import"
      ></ButtonNew>
    </div>
    <AnonymizationListUi
      {idAnonymization}
      editable={true}
      {uilistfilterelements}
      bind:currentAnonymizationRule={currentAnonymizationRuleUI}
      bind:anonymizationRuleModalOpen={anonymizationRuleModalOpenUI}
    />

    <div class="selection_wrapper">
      <div class="select_wrapper">
        <ComboBox
          titleText="Application"
          placeholder="Select or type..."
          size="sm"
          bind:selectedId={uilistfilter.applicationname}
          items={[
            ...(uilistfilterelements?.applicationname || []).map((app) => ({
              id: app,
              text: app,
            })),
          ]}
          {shouldFilterItem}
        />
      </div>
      <div class="select_wrapper">
        <ComboBox
          titleText="Class"
          placeholder="Select or type..."
          size="sm"
          bind:selectedId={uilistfilter.elementclass}
          items={[
            ...(uilistfilterelements?.elementclass || []).map((cls) => ({
              id: cls,
              text: cls,
            })),
          ]}
          {shouldFilterItem}
        />
      </div>
      <div class="select_wrapper">
        <ComboBox
          titleText="Type"
          size="sm"
          placeholder="Select or type..."
          bind:selectedId={uilistfilter.type}
          items={[
            ...(uilistfilterelements?.type || []).map((t) => ({
              id: t,
              text: t,
            })),
          ]}
          {shouldFilterItem}
        />
      </div>
      <div class="select_wrapper">
        <TextInput
          labelText="Name"
          size="sm"
          bind:value={uilistfilter.name}
          title={uilistfilter.name}
          placeholder="Name"
        />
      </div>
      <div class="select_wrapper">
        <TextInput
          labelText="Automation ID"
          size="sm"
          bind:value={uilistfilter.automationid}
          title={uilistfilter.automationid}
          placeholder="Automation ID"
        />
      </div>
      <div class="select_wrapper">
        <Select
          size="sm"
          labelText="In Task Recording"
          bind:selected={uilistfilter.in_task_recording}
        >
          <SelectItem value={"*"} text="All" />
          <SelectItem value={"yes"} text="In Task Recording" />
          <SelectItem value={"no"} text="Not in Task Recording" />
        </Select>
      </div>
      <Button
        size="small"
        kind="tertiary"
        icon={Edit16}
        on:click={() => {
          newRuleFromEntryUI(uilistfilter);
        }}
        iconDescription="Create Rule From Entry"
      ></Button>
    </div>

    <DataTable
      size="short"
      headers={[
        { key: "applicationname", value: "Application", width: "200px" },
        // { key: "name", value: "Name" },
        { key: "namepreview", value: "Name", width: "200px" },
        // { key: "automationid", value: "Automation ID" },
        { key: "automationpreview", value: "AutoID", width: "200px" },
        { key: "elementclass", value: "Class" },
        { key: "type", value: "Type", width: "100px" },
        { key: "count", value: "Count", width: "100px" },
        { key: "menu", empty: true, width: "80px" },
      ]}
      rows={uilist}
      sortable
      page={uipage}
      pageSize={uipageSize}
      sortDirection="desc"
      sortKey="count"
    >
      <svelte:fragment slot="cell" let:cell let:row>
        {#if cell.key === "menu"}
          <Button
            size="small"
            kind="tertiary"
            icon={Edit16}
            on:click={() => {
              newRuleFromEntryUI(row);
            }}
            iconDescription="Create Rule From Entry"
          ></Button>
        {:else if cell.key !== "menu"}
          {cell.value}
        {/if}
      </svelte:fragment>
    </DataTable>
    <Pagination
      totalItems={uilist.length}
      pageSizes={[10, 25, 50]}
      bind:page={uipage}
      bind:pageSize={uipageSize}
    />

    <ButtonNew
      secondary={true}
      setting={true}
      text="Get UI Elements"
      on:click={getUIElements}
    />
    <!-- @Adrian nur auskommentiert, falls neuer button spinnen sollte -->
    <!-- <Button on:click={getUIElements}>Apply Rules</Button> -->

    <!-- @Adrian bitte ausfüllen, was genau das ist -->

    <div class="table_heading">
      <!-- <h5>Lorem Ipsum</h5> -->
      <div class="info">
        Specify applications, that should be only recorded when an anonymization
        rule is matched.
      </div>
    </div>

    <LimitationList></LimitationList>

    <div style="text-align:right">
      {#if !isCompleted}
        <TextArea
          labelText="Message"
          placeholder="Enter a message for the users"
          bind:value={message}
        />
        <ButtonNew
          secondary={true}
          setting={true}
          text="Go to Main Recording"
          on:click={goMainRecording}
        />
        <!-- @Adrian nur auskommentiert, falls neuer button spinnen sollte -->
        <!-- <Button on:click={goMainRecording}>Go to Main Recording</Button> -->
      {/if}
    </div>
  </div>
</SectionWrapper>

<style>
  .main {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_heading {
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    background-color: #fc8b5d;
    color: var(--pax-white);
    border-left: 0.6rem solid var(--pax-orange);
    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
  }

  .info_wrapper {
    background: var(--pax-black);
    color: white;
    border-left: 0;
  }

  .selection_wrapper {
    display: flex;
  }

  .select_wrapper {
    flex: 1;
    min-width: 0;
  }
</style>
